import { endOfMonth, format, startOfMonth } from 'date-fns';

/** Calendar month range formatted for trial APIs (yyyy-MM-dd). */
export function getTrialMonthDateRange(referenceDate: Date = new Date()) {
  const start = startOfMonth(referenceDate);
  const end = endOfMonth(referenceDate);
  return {
    startDate: format(start, 'yyyy-MM-dd'),
    endDate: format(end, 'yyyy-MM-dd'),
  };
}
